exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "competition-details .label {\n  font-weight: bolder; }\n\ncompetition-details .card {\n  padding: 5px; }\n  competition-details .card h1, competition-details .card h2, competition-details .card h3, competition-details .card h4 {\n    text-decoration: underline;\n    margin: 5px 0px; }\n\ncompetition-details .missing-data {\n  margin-top: 25px;\n  font-weight: bold;\n  font-size: large; }\n\ncompetition-details .mat-column-roundNo {\n  -ms-flex: 1 0 10%;\n      flex: 1 0 10%; }\n\ncompetition-details .mat-column-courseNames {\n  -ms-flex: 1 0 50%;\n      flex: 1 0 50%; }\n\ncompetition-details .mat-column-roundDate {\n  -ms-flex: 1 0 20%;\n      flex: 1 0 20%; }\n\ncompetition-details .mat-column-status {\n  -ms-flex: 1 0 20%;\n      flex: 1 0 20%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/competition-details/competition-details.component.scss
// module id = ../../../../../src/app/component-module/competition-details/competition-details.component.scss
// module chunks = main